module.exports = __webpack_public_path__ + "static/media/icon-broken-tablet.29d985d8.svg";